import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import {HelmetProvider} from 'react-helmet-async';
import { LanguageProvider } from './i18n/LanguageContext';
import { ContactModalProvider } from './components/ContactModalContext';
import './index.css';
import App from './App';
import reportWebVitals from './monitor/reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <LanguageProvider>
        <ContactModalProvider>
          <App />
        </ContactModalProvider>
      </LanguageProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
